require('./unreadMessageBar.scss');
const template = require('./unreadMessageBar.html');

const deps = [];

const unreadMessageBarComponent = {
  template,
  controllerAs: 'vm',
  bindings: {
    count: '<',
    date: '<',
    onJump: '&',
    onMarkAsRead: '&',
  },
};

module.exports = angular
  .module('bench.ui.unreadMessageBar', deps)
  .component('blUnreadMessageBar', unreadMessageBarComponent);
